import { IssueFieldEnum } from "@mcapps/shared/enums";
import { CellEditRequestEvent } from "ag-grid-community";
import { useCallback } from "react";
import { IIssueApi } from "@schemas/issueSchema";
import { parseNorwegianDate } from "../../../admin/selectors";

import { getLogValueFromCellValue } from "./issueTableFormatters";

export const useIssueTableCellEditing = ({
  issueBoardId,
  projectId,
  updateIssue,
  updateIssueSimple,
}: {
  issueBoardId: string;
  projectId: string;
  updateIssue: (args: any) => void;
  updateIssueSimple: (args: any) => void;
}) => {
  return useCallback(
    (event: CellEditRequestEvent<IIssueApi>) => {
      const issue = event.data;
      const field = event.colDef.field;

      if (issue == null || field == null) {
        return;
      }

      let updateValue: any;
      if (field.startsWith("status")) {
        updateValue = event.newValue;
      } else if (field.startsWith("priority")) {
        updateValue = event.newValue;
      } else if (field.startsWith("dates")) {
        if (event.newValue == null) {
          updateValue = "";
        } else {
          const newDate = parseNorwegianDate(event.newValue);
          const oldDate = parseNorwegianDate(event.oldValue);

          if (newDate && oldDate && newDate.getTime() === oldDate.getTime()) {
            return;
          }

          updateValue = newDate;
        }
      } else {
        updateValue = event.newValue;
      }

      if (
        field === IssueFieldEnum.TITLE ||
        field === IssueFieldEnum.DESCRIPTION ||
        field === IssueFieldEnum.CONCLUSION ||
        field === IssueFieldEnum.REFERENCEURL
      ) {
        updateIssueSimple({
          projectId,
          body: {
            _id: issue._id,
            property: {
              [field]: updateValue,
            },
          },
        });
        return;
      }

      updateIssue({
        projectId,
        issueId: issue._id,
        attr: field,
        value: updateValue,
        oldValue: getLogValueFromCellValue(event.oldValue),
        issueBoardId,
      });
    },
    [issueBoardId, projectId, updateIssue, updateIssueSimple],
  );
};
